var ConsoleErrorLogger = /** @class */ (function () {
    function ConsoleErrorLogger() {
    }
    ConsoleErrorLogger.prototype.logError = function (error, userInfo, extraInfo) {
        if (userInfo === void 0) { userInfo = null; }
        if (extraInfo === void 0) { extraInfo = null; }
        console.error(error);
        // eslint-disable-next-line no-console
        console.log(userInfo, extraInfo);
    };
    return ConsoleErrorLogger;
}());
export { ConsoleErrorLogger };
